import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { APP_VERSION } from '../../core/constants/app.constant';
import { AuthBgImageEnum, getAuthBgImage } from '../../core/constants/auth-image.constant';

@Component({
    selector: 'app-auth-layout',
    standalone: false,
    templateUrl: './auth-layout.component.html',
    styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
    protected APP_VERSION = APP_VERSION;

    protected bgImage!: string;

    private destroy$ = new Subject<void>();

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.loadBgImage();

        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this.destroy$),
            )
            .subscribe({
                next: () => this.loadBgImage(),
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private loadBgImage(): void {
        const bgImageEnum = this.getBgImage();

        this.bgImage = getAuthBgImage(bgImageEnum);
    }

    private getBgImage(): AuthBgImageEnum {
        let route = this.activatedRoute;

        while (route.firstChild) {
            route = route.firstChild;
        }

        return route.snapshot.data['bgImage'];
    }
}
